<template>
    <div>
        <h3 class="t-c c-theme">Total Contratos {{entity.proposals_count | formatNumber(0)}}</h3>
        <div class="container-fluid-grid" v-if="$appUtils.isDesktop()">
            <div class="row">
                <div class="col-12">
                    <table class="table table-striped table-sm">
                        <thead class="thead-dark thead-center">
                        <tr>
                            <th style="width: 60px">Pago?</th>
                            <th style="width: 100px">Data</th>
                            <th style="width: 100px">Número</th>
                            <th>Vendedor</th>
                            <th>Comprador</th>
                            <th>Produto</th>
                            <th style="width: 100px">Quantidade</th>
                            <th style="width: 100px">Preço</th>
                            <th style="width: 120px">Comissão</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(p) in result.proposals"
                            :key="p.id">
                            <td class="t-c paid" :class="{yes: p.paid}">
                                <svg-icon :icon="p.paid ? 'thumbs-up' : 'thumbs-down'"/>
                            </td>
                            <td class="ellipsis t-c">{{p.created_at | formatDate}}</td>
                            <td class="ellipsis t-c">
                                <router-link :to="`/proposals/${p.id}/edit`" class="link-theme">{{p.number}}</router-link>
                            </td>
                            <td class="ellipsis" :class="{'f-w-700': p.group_seller.id === entity.customer_group_id}">{{p.group_seller.name}}</td>
                            <td class="ellipsis" :class="{'f-w-700': p.group_buyer.id === entity.customer_group_id}">{{p.group_buyer.name}}</td>
                            <td class="ellipsis">
                                <router-link :to="`/products/${p.product.id}/edit`" class="link-theme">{{p.product.name}}</router-link>
                            </td>
                            <td class="ellipsis t-r">{{p.quantity | formatNumber(3)}}</td>
                            <td class="ellipsis t-r">{{p.price | formatMoney}}</td>
                            <td class="ellipsis t-r f-w-700">{{p.broker_commission | formatMoney}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else class="grid-mobile"
             v-for="(p) in result.proposals"
             :key="p.id">
            <span class="date">{{p.created_at | formatDate}}</span>
            <span class="prop"><router-link :to="`/proposals/${p.id}/edit`"
                                            class="link-theme">{{p.number}}</router-link></span>

            <span class="seller ellipsis" :class="{'f-w-700': p.group_seller.id === entity.customer_group_id}">
                        <span class="label">Vendedor</span>
                        {{p.group_seller.name}}
                    </span>
            <span class="buyer ellipsis" :class="{'f-w-700': p.group_buyer.id === entity.customer_group_id}">
                        <span class="label">Comprador</span>
                        {{p.group_buyer.name}}
                    </span>

            <span class="prod ellipsis">
                        <span class="label">Produto</span>
                        {{p.product.name}}
                    </span>
            <span class="qtd">
                        <span class="label">Quantidade</span>
                        {{p.quantity | formatNumber(3)}} (Tons)
                    </span>

            <span class="price">
                        <span class="label">Preço</span>
                        R$ {{p.price | formatMoney}}
                    </span>
            <span class="comm">
                <span class="label">Comissão</span><br/>
                <svg-icon :icon="p.paid ? 'thumbs-up' : 'thumbs-down'" :svg-class="{paid: p.paid}"/>
                <span class="val">R$ {{p.broker_commission | formatMoney}}</span>
            </span>
        </div>

        <div ref="intersect" class="t-c refresh-container">
            <svg-icon icon="sync" svg-class="refresh load-more-crud" v-if="searching"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProposalsTab",
        props: {
            entity: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                result: {
                    total_commission: 0,
                    proposals: []
                },
                observerPagination: null,
                currentPage: 1,
                searching: false,
                isEnd: false
            }
        },
        methods: {
            loadMore() {
                if (this.entity.id && !this.searching && !this.isEnd){
                    this.searching = true;
                    this.$appHttp.get(`/v1/users/load_proposals?page=${this.currentPage++}`)
                        .then(({data}) => {
                            this.result.proposals.push(...data.proposals);
                            this.isEnd = data.length === 0;
                        })
                        .catch(err => {
                            this.$appUtils.vibrate();
                            this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema ao carregar as confirmações de negócios.'}), this.$appStorage.getUser().name);
                            console.error(err);
                        })
                        .finally(() => this.searching = false)
                }
            }
        },
        mounted() {
            this.loadMore();

            this.observerPagination = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) this.loadMore()
                })
            }, {
                root: null,
                rootMargin: '400px'
            });

            this.observerPagination.observe(this.$refs.intersect);
        },
        destroyed() {
            if (this.observerPagination) {
                this.observerPagination.disconnect();
                this.observerPagination = null;
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../assets/css/variables";
    .refresh-container {
        svg {
            width: 2em;
            height: 2em;
        }
    }

    .paid {
        color: $fixed_expenses_main_color;

        &.yes {
            color: $income_main_color;
        }

        svg {
            width: 1em;
            height: 1em;
        }
    }

    .grid-mobile {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas: 'date prop' 'seller buyer' 'prod qtd' 'price comm';
        grid-template-rows: auto;
        grid-gap: 5px;
        padding: 5px;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        font-size: .8em;

        .label {
            display: block;
            font-weight: bold;
            font-size: .8em;
        }

        .date{grid-area: date}
        .prop{
            grid-area: prop;
            text-align: right;
        }

        .seller{grid-area: seller}
        .buyer{
            grid-area: buyer;
            text-align: right;
        }

        .prod{grid-area: prod}
        .qtd{
            grid-area: qtd;
            text-align: right;
        }

        .price{
            grid-area: price;
            font-weight: 700;
        }
        .comm{
            span {
                display: inline-block;

                &.val {
                    color: $theme_color_one;
                    font-size: 1.3em;
                }
            }
            svg {
                width: 1.3em;
                height: 1.3em;
                color: $fixed_expenses_main_color;
                margin-right: 5px;

                &.paid {
                    color: $income_main_color;
                }
            }
            grid-area: comm;
            text-align: right;
        }
    }
</style>
